import { useCallback } from 'react'
import debounce from 'lodash/debounce'
import { InputDropdownR } from '@cb/apricot-react'
import { CBInputMethod } from '@cb/apricot'
import CBUtils from '@cb/apricot/CBUtils'
import { isEmpty } from '@myap/ui-library'

function Autosuggest({
  name,
  label,
  placeholder = '',
  disabled,
  floating = false,
  clearable = true,
  icon = 'search',
  iconRight = true,
  scrollLimit = 10,
  itemHeight = 48,
  required,
  dropDownItemFunc,
  callBackFunc,
  itemLabelFunc,
  onClearFunc,
  onChange,
  onBlur,
  value,
  validation,
  validationMsg,
  fetchSuggestions,
  processSuggestions,
  minCharacterSearchLength = 3,
}) {
  const inputRef = useRef(null)
  const [suggestions, setSuggestions] = useState([])
  const [total, setTotal] = useState(0)

  useEffect(() => {
    // A11Y
    CBInputMethod()
  }, [])

  async function fetch(value) {
    const { suggestions: newSuggestions, total: newTotal } = await fetchSuggestions(value)
    const processedSuggestions = processSuggestions(newSuggestions)
    setSuggestions(processedSuggestions)
    setTotal(newTotal)
  }

  const debouncedSearch = useCallback(
    debounce(newSearch => fetch(newSearch), 500),
    []
  )

  return (
    <InputDropdownR
      ref={inputRef}
      name={name}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      floating={floating}
      clearable={clearable}
      icon={icon}
      iconRight={iconRight}
      dropdownOverlay
      itemHeight={itemHeight}
      required={required}
      dataItems={suggestions}
      dropDownItemFunc={dropDownItemFunc}
      callBack={callBackFunc}
      itemLabelFunc={itemLabelFunc}
      openOnLoad={false}
      onClear={onClearFunc}
      onChange={(event, value) => {
        // Bail if this event resulted from a mouse click or pressing ENTER
        if (event.type === 'click' || event.keyCode === CBUtils.KEYS.ENTER) {
          return
        }

        if (!isEmpty(value) && value?.length >= minCharacterSearchLength) {
          debouncedSearch(value)
        }
        if (onChange) {
          onChange(value)
        }
      }}
      onBlur={onBlur}
      value={value}
      defaultValue={value}
      validation={validation}
      validationMsg={validationMsg}
      shadowRoot
    />
  )
}

export default Autosuggest
